/**
 * 应用配置文件
 * 统一管理所有API和图片的URL配置
 */

// 环境配置
const isProduction = process.env.NODE_ENV === 'production'
const isDevelopment = process.env.NODE_ENV === 'development'

// API配置
export const API_CONFIG = {
  // API基础URL
  BASE_URL: process.env.VUE_APP_API_BASE_URL || 'https://api.sainbainu.com/',
  
  // 商城相关API
  MALL_BASE_URL: 'https://mall.sainbainu.com/',
  
  // 图片服务器配置 - 开发环境使用代理，生产环境使用直接域名
  IMAGE_BASE_URL: isDevelopment ? '/image/' : 'https://image.sainbainu.com/',
  
  // 上传服务器配置
  UPLOAD_BASE_URL: 'https://upload.sainbainu.com/'
}

// 图片配置
export const IMAGE_CONFIG = {
  // 默认图片
  DEFAULT_LOGO: 'https://mall.sainbainu.com/static/images/sharelogo.png', // 使用绝对URL确保微信能访问
  DEFAULT_AVATAR: '/static/images/default-avatar.png',
  
  // 商品图片
  PRODUCT_IMAGE_BASE: isDevelopment ? '/image/uploads/products/' : 'https://image.sainbainu.com/uploads/products/',
  
  // 分类图片
  CATEGORY_IMAGE_BASE: isDevelopment ? '/image/uploads/categories/' : 'https://image.sainbainu.com/uploads/categories/',
  
  // 用户头像
  USER_AVATAR_BASE: isDevelopment ? '/image/uploads/avatars/' : 'https://image.sainbainu.com/uploads/avatars/'
}

// 微信配置
export const WECHAT_CONFIG = {
  // 微信开放平台配置
  OPEN_PLATFORM: {
    APP_ID: process.env.VUE_APP_WECHAT_OPEN_APP_ID || '',
    APP_SECRET: process.env.VUE_APP_WECHAT_OPEN_APP_SECRET || '',
    SCOPE: 'snsapi_login',
    REDIRECT_URI: isProduction 
      ? 'https://yourdomain.com/login' 
      : 'http://localhost:8080/login'
  },
  
  // 微信公众号配置
  OFFICIAL_ACCOUNT: {
    APP_ID: process.env.VUE_APP_WECHAT_MP_APP_ID || '',
    APP_SECRET: process.env.VUE_APP_WECHAT_MP_APP_SECRET || '',
    SCOPE: 'snsapi_userinfo',
    REDIRECT_URI: isProduction 
      ? 'https://yourdomain.com/login' 
      : 'http://localhost:8080/login'
  }
}

// 支付配置
export const PAY_CONFIG = {
  // 微信支付配置
  WECHAT: {
    MCH_ID: process.env.VUE_APP_WECHAT_MCH_ID || '',
    API_KEY: process.env.VUE_APP_WECHAT_API_KEY || '',
    NOTIFY_URL: isProduction 
      ? 'https://yourdomain.com/api/pay/wechat/notify'
      : 'http://localhost:8080/api/pay/wechat/notify'
  }
}

// 应用配置
export const APP_CONFIG = {
  // 应用名称
  NAME: '蒙古丽人商城',
  
  // 应用描述
  DESCRIPTION: '发现更多精美商品，享受优质购物体验',
  
  // 版本信息
  VERSION: '1.0.0',
  
  // 开发环境标识
  IS_DEVELOPMENT: isDevelopment,
  
  // 生产环境标识
  IS_PRODUCTION: isProduction
}

// 导出默认配置
export default {
  API_CONFIG,
  IMAGE_CONFIG,
  WECHAT_CONFIG,
  PAY_CONFIG,
  APP_CONFIG
}

